import Button from '@v2/shared/components/Button';
import useIntersectionObserver from '@v2/shared/lib/useIntersectionObserver';
import { cn } from '@v2/shared/lib/utils';

type Props = {
  onClick: () => void;
};

/**
 * The mobile sticky CTA. It hides itself while the form is on screen, which is what the
 * sentinel above it is for — the sentinel sits inside the form card, so "visible" means
 * "the form is already in front of them".
 */
export default function FloatingQuoteCta({ onClick }: Props) {
  const [sentinelRef, isFormVisible] = useIntersectionObserver();

  return (
    <>
      <div ref={sentinelRef} />
      <div
        aria-hidden={isFormVisible}
        className={cn(
          'fixed bottom-0 left-0 right-0 z-50 md:hidden',
          'bg-white border-0 border-t-2 border-solid border-slate-200',
          'px-5 py-4 flex justify-center',
          'transition-transform duration-300 ease-in-out',
          isFormVisible ? 'translate-y-full' : 'translate-y-0'
        )}
      >
        <Button size="lg" shape="rounded" onClick={onClick} fullWidth>
          Get My Free Quote
        </Button>
      </div>
    </>
  );
}
